export const TaskManager = window.TaskManagerModule.TaskManager;